import React, { Component } from 'react';
import 'semantic-ui-css/semantic.min.css';
import { Modal, Button, Checkbox } from '../../../../node_modules/semantic-ui-react';
import FilterGroupSection, { emptyFilterGroup, normalizeFilterGroup } from '../../../Commons/FilterGroupSection';

class EmployeeReportModalGroupByDepartment extends Component {

    constructor(props) {
        super(props);
        var defaultState = {
            filterGroup: emptyFilterGroup(),
            includeDeleted:false,
            includeInactive:false,
        };

        const savedState = sessionStorage.getItem("EmployeeReportGroupByDepartmentFilterState");
        if (savedState) {
            try {
                const parsed = JSON.parse(savedState);
                this.state = { ...defaultState, ...parsed, filterGroup: normalizeFilterGroup(parsed.filterGroup) };
            } catch (e) {
                this.state = defaultState;
            }
        } else {
            this.state = defaultState;
        }
    }

    componentWillUnmount() {
        const stateToSave = {
            filterGroup: this.state.filterGroup,
            includeInactive: this.state.includeInactive
        };
        sessionStorage.setItem("EmployeeReportGroupByDepartmentFilterState", JSON.stringify(stateToSave));
    }

    getParameters = () => {
        return {
            ...this.state.filterGroup,
            message: "from employee report group by department modal",
            DepartmentID: "",
            includeDeleted:this.state.includeInactive,
            startingIndex:0,
            itemCount:20,
            FilterDetails: this.state.filterGroup.filterGroupDetails || "Department: ALL"
        };
    }
    onChkCheckChange = (e) => {
        this.setState({ includeInactive: !this.state.includeInactive })
    }
    render() {
        return (
            <Modal open={this.props.open} size="tiny">
                <Modal.Header>
                    <p>Employee Report Group By Department Filters</p>
                </Modal.Header>
                <Modal.Content>
                    <div class="ui grid">
                        <div class="left floated left aligned sixteen wide column">
                            <Checkbox size='mini' 
                                label="Include Resigned" 
                                onChange={this.onChkCheckChange.bind(this)} 
                                checked={this.state.includeInactive} />
                        </div>
                    </div>
                    <div class="ui grid">
                        <div class="left floated left aligned sixteen wide column">
                            <FilterGroupSection value={this.state.filterGroup} onChange={filterGroup => this.setState({ filterGroup })} />
                        </div>
                    </div>
                </Modal.Content>
                <Modal.Actions>
                    <Button basic content="Generate" onClick={this.props.onSave}></Button>
                    <Button basic content="Cancel" onClick={this.props.onCancel}></Button>
                </Modal.Actions>
            </Modal>
        );
    }

}

export default EmployeeReportModalGroupByDepartment;